module.exports = __webpack_public_path__ + "img/android.11e6738d.svg";